import { render } from "./StatisticaInformationPage.vue?vue&type=template&id=44a5ae98"
import script from "./StatisticaInformationPage.vue?vue&type=script&lang=js"
export * from "./StatisticaInformationPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__